import { ApolloError } from '@apollo/client';

type GraphQLErrorLike = {
  message?: string | null;
};

type NetworkErrorWithResult = Error & {
  result?: {
    errors?: GraphQLErrorLike[];
  };
};

const getTrimmedMessage = (message?: string | null) => {
  if (!message) return undefined;

  const trimmedMessage = message.trim();
  return trimmedMessage === '' ? undefined : trimmedMessage;
};

export const getApolloErrorMessage = (
  error?: ApolloError | null
): string | undefined => {
  const graphQLErrorMessage = error?.graphQLErrors
    ?.map((graphQLError) => getTrimmedMessage(graphQLError.message))
    .find(Boolean);

  if (graphQLErrorMessage) {
    return graphQLErrorMessage;
  }

  const networkError = error?.networkError as
    | NetworkErrorWithResult
    | undefined;
  const networkGraphQLErrorMessage = networkError?.result?.errors
    ?.map((graphQLError) => getTrimmedMessage(graphQLError.message))
    .find(Boolean);

  if (networkGraphQLErrorMessage) {
    return networkGraphQLErrorMessage;
  }

  return (
    getTrimmedMessage(networkError?.message) ||
    getTrimmedMessage(error?.message)
  );
};
